export default function scrollToTop() {
  setTimeout(function () {
    window.scrollTo(0, 0)
  }, 0)
}
